
import $ from 'jquery';
import 'jquery';
import { Power3, gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/all';

$(() => {

  gsap.registerPlugin(ScrollToPlugin);

  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('.nav-item')
  .on('click', function(e) {


    e.preventDefault();

    let url = $(this).attr('href');
    let target = url.substr(url.indexOf('#')+1);

    if ($('#' + target).length) {
      gsap.to(window, {
        duration: .2,
        //ease: Power3.easeInOut,
        ease: "none",
        scrollTo: {
          y: '#' + target,
          offsetY: $('#site-header .navbar').outerHeight(true)+60,
        }
      })
    }
  })
});
